/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="24.84" height="25.2" viewBox="0 0 24.84 25.2" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path fill="none" stroke="#1570bc" d="M5.87.5h11.65a1.49 1.49 0 0 1 1 .42l5.32 5.13a1.47 1.47 0 0 1 .46 1.08V23.2a1.5 1.5 0 0 1-1.5 1.5h-17a1.5 1.5 0 0 1-1.5-1.5V2A1.5 1.5 0 0 1 5.87.5Z" className="icon-stroke"/>
        <path fill="none" stroke="#1570bc" d="M18.4.96v4.35a1 1 0 0 0 1 1h4.49" className="icon-stroke" strokeLinejoin="round" strokeLinecap="round"/>
        <rect width="19.98" height="9.24" y="9.48" fill="#1570bc" rx="1" className="icon-fill"/>
        <path fill="#fff" d="M3.6 17.31V15h1.14a1.89 1.89 0 0 0 2.13-2c0-1.23-.73-1.91-2.2-1.91H2.5v6.22Zm.94-3.16H3.6v-2.21h1c.83 0 1.15.32 1.15 1.14s-.36 1.1-1.21 1.1Zm5.41 3.16c2 0 3-1.1 3-3.1v-.19c0-2-1.08-3-3-3H7.89v6.29Zm0-.87h-1v-4.48h.88c1.19 0 1.89.5 1.89 2.08v.27c.04 1.56-.51 2.16-1.76 2.16Zm5.19.87v-2.6h2.12v-.86h-2.11v-1.89h2.73v-.86h-3.83v6.21Z"/>
      </svg>
    );
  }
}

Icon.displayName = 'PdfIcon';

export default Icon;
